import { lazy } from 'react';
import withLoadableComponent from './withLoadableComponent';
import retry from '../utils/webpack/chunkRetry';
export var LoadablePostPopup = withLoadableComponent(lazy(function () {
    return retry(function () {
        return import(
        /* webpackChunkName: "postpopup" */
        '../PostPopup');
    });
}));
export var LoadableWriterPopup = withLoadableComponent(lazy(function () {
    return retry(function () {
        return import(
        /* webpackChunkName: "writerpopup" */
        '../WriterPopup');
    });
}));
export var LoadableCommissionEditPopup = withLoadableComponent(lazy(function () {
    return retry(function () {
        return import(
        /* webpackChunkName: "commissioneditpopup" */
        '../CommissionEditPopup');
    });
}));
export var LoadablePollEditPopup = withLoadableComponent(lazy(function () {
    return retry(function () {
        return import(
        /* webpackChunkName: "polleditpopup" */
        '../PollEditPopup');
    });
}));
export var LoadableAddToCollectionPopoverModal = withLoadableComponent(lazy(function () {
    return retry(function () {
        return import(
        /* webpackChunkName: "actionbar" */
        '../ActionBar/_partials/AddToCollectionPopup/AddToCollectionModal');
    });
}));
export var LoadableDasModal = withLoadableComponent(lazy(function () {
    return retry(function () {
        return import(
        /* webpackChunkName: "das" */
        '../Das/DasModal');
    });
}));
export var LoadableTierPopup = withLoadableComponent(lazy(function () {
    return retry(function () {
        return import(
        /* webpackChunkName: "tierpopup" */
        '../Tier/TierPopup');
    });
}));
export var LoadableDealerPopup = withLoadableComponent(lazy(function () {
    return retry(function () {
        return import(
        /* webpackChunkName: "dealerpopup" */
        '../DealerPopup');
    });
}));
//# sourceMappingURL=LoadableModals.js.map